export default function ($filter) {
	return function (property) {
		if(property) {

			// fordítások
			let room = $filter('translate')('AKEDV.room');
			let and = $filter('translate')('AKEDV.and');
			let half = $filter('translate')('AKEDV.half');
			let rooms = $filter('translate')('AKEDV.rooms');

			let retValue = Number.isInteger(parseInt(property.numberOfRooms, 10)) ? property.numberOfRooms + ' ' + room : '';
			if (property.numberOfHalfRooms == 1) {
				retValue += retValue ? ' ' + and + ' 1 ' + half + ' ' + room : half + ' ' + room;
				return retValue;
			} else if (property.numberOfHalfRooms) {
				return retValue ? retValue + ' ' + and + ' ' + property.numberOfHalfRooms + ' ' + half + ' ' + rooms : property.numberOfHalfRooms + ' ' + half + ' ' + rooms;
			} else {
				return retValue;
			}
		}
	};
}
